import { __generator } from "tslib";
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request, isApiError } from '../../xhr';
import { requestEarningsCalculation, requestEarningsCalculationSuccess, requestEarningsCalculationError, } from './actionCreators';
export function sendCalculateEarningsRequest(dollarPrice, productType) {
    var params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = { dollar_price: dollarPrice, product_type: productType };
                ddt.log('shared', 'fetching earnings calculation', params);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/user/calculate_earnings",
                        data: params,
                    }, function () { return ({ dollarPrice: '10', serviceFee: '1.2', dollarEarnings: '8.8' }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
export function handleRequestEarningsCalculation(action) {
    var _a, dollarPrice, productType, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, delay(1000)];
            case 1:
                _b.sent(); // + takeLatest = debounced
                _a = action.payload, dollarPrice = _a.dollarPrice, productType = _a.productType;
                return [4 /*yield*/, sendCalculateEarningsRequest(dollarPrice, productType)];
            case 2:
                result = _b.sent();
                if (!(!result || isApiError(result) || result.error)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(requestEarningsCalculationError(result.error))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(requestEarningsCalculationSuccess(result))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(requestEarningsCalculation, handleRequestEarningsCalculation)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map